import { useEffect, useRef } from 'react';
import {
  isWithinBusinessHours,
  normalizeChatSchedule,
} from '../utils/chatAvailability';
import trackHeapEvent from '../services/helpers/trackHeapEvent';

export default function useOracleHelpChat(
  shouldInitialize = false,
  chatConfig = null,
  chatScriptURL = '',
  oracleChatWidget = null
) {
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (!chatConfig || !chatScriptURL) return undefined;

    const initializeChat = () => {
      if (window.re) {
        window.re.load(chatConfig);
        hasLoadedRef.current = true;
      } else {
        const script = document.createElement('script');
        script.type = 'module';
        script.id = 'oracle-chat-embedded-loader';

        script.textContent = `
          ${chatScriptURL}
          const config = ${chatConfig};
          if (typeof re !== 'undefined') {
            window.re = re;
            re.load(config);
          }
        `;
        document.body.appendChild(script);
        hasLoadedRef.current = true;
      }
    };
    const toggleVisibility = (visible) => {
      const elements = document.querySelectorAll('.es-launch-button');
      elements.forEach((element) => {
        const el = element;
        el.style.visibility = visible ? 'visible' : 'hidden';
      });
    };

    if (shouldInitialize) {
      const schedule = normalizeChatSchedule(oracleChatWidget);
      const chatOpen = isWithinBusinessHours(schedule);

      if (!hasLoadedRef.current && chatOpen) {
        initializeChat();
      }
      toggleVisibility(chatOpen);

      if (chatOpen) {
        const handleClick = (e) => {
          if (e.target.closest('.es-launch-button')) {
            trackHeapEvent(
              { chatStatus: 'clicked' },
              'website_deposit_chat_clicked'
            );
          }
        };
        document.addEventListener('click', handleClick);
        return () => {
          document.removeEventListener('click', handleClick);
          toggleVisibility(false);
        };
      }
    } else {
      toggleVisibility(false);
    }
    return () => {
      toggleVisibility(false);
    };
  }, [shouldInitialize, chatConfig, chatScriptURL, oracleChatWidget]);
}
